<app-home-main-banner></app-home-main-banner>
<app-vision-mission></app-vision-mission>
<app-home-article></app-home-article>
<app-how-to-publish></app-how-to-publish>
<app-home-book></app-home-book>
<app-home-event></app-home-event>
<app-home-project></app-home-project>
<app-how-to-apply></app-how-to-apply>
<app-home-blog></app-home-blog>
<app-home-donor></app-home-donor>
